import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FrameCard, Input } from '@weezevent/nacre';
import { LanguageSelector } from '../../../../nacre/components/LanguageSelector';

export default function WidgetGeneralInformation({ form, setForm, formErrors, widget }) {
    const { t } = useTranslation();
    let lang =
        form.default_language.indexOf('-') > -1
            ? form.default_language.substring(0, form.default_language.indexOf('-')) + form.default_language.substring(form.default_language.indexOf('-')).toUpperCase()
            : form.default_language;

    return (
        <FrameCard title={t('ticket.personal_spaces.settings.general-information.title')}>
            <Form.Field>
                <Form.Label label={t('ticket.personal_spaces.settings.general-information.name')} />
                <Input value={form.name} onChange={event => setForm('name', event.target.value)} max={256} />
                <Form.FieldErrors errors={[formErrors['name'] && t(formErrors['name'])]} />
            </Form.Field>
            <LanguageSelector
                label={t('ticket.personal_spaces.settings.general-information.default_language')}
                lang={lang}
                onChange={(event, { value }) => {
                    setForm('default_language', value);
                }}
                arrayLangDefault={form.languages}
                errorField={formErrors['default_language']}
            />
        </FrameCard>
    );
}
